<app-header id="app-header"></app-header>
<div [hidden]="!navigating">
  <app-spinner></app-spinner>
</div>
<div [hidden]="navigating">
  <router-outlet></router-outlet>
</div>
